// extracted by mini-css-extract-plugin
export var placeholder = "getthumbnail-module--placeholder--ULa2f";